import {
    StaticComponent
} from "../../../../../../sedestral/router/static/component/StaticComponent";
import * as s from "./loaders-page.scss";
import {
    LoaderLightComponent
} from "../../../../../components/global/loader/light/LoaderLightComponent";

export class PageLoaderStatic extends StaticComponent {

    constructor() {
        super();
        this.virtual(s.staticPageLoaders);
        //language=HTML
        this.template = ``;
    }

    init(): void {
        this.show();
        this.setStyle(`transform:scale(1);opacity:1;transition-duration:0s;opacity:1;`);
        this.append(this.draw(new LoaderLightComponent()));
        super.init();
    }

    remove() {
        this.clear();
        this.hide();
    }

    async animateRemove() {
        this.setStyle(`transform:scale(1);opacity:1;`);
        await this.translate({
            delay: 80,
            scale: 0.9,
            opacity: 0
        });

        this.remove();
    }
}